export class UserModel {
    constructor(data) {
        this.id = data.id;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.lastLoginAt = data.lastLoginAt;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.fullName = data.fullName;
        this.keycloakId = data.keycloakId;
        this.canLogin = data.canLogin;
        this.notification = data.notification;
    }
}